import {
  CheckCircle2 as CheckCircleIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  AlertTriangle as AlertTriangleIcon,
  X as XIcon,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { useToastStore } from "@/hooks/useToast";
import styles from "./Toasts.module.css";

const ICONS = {
  success: CheckCircleIcon,
  error: AlertCircleIcon,
  info: InfoIcon,
  warning: AlertTriangleIcon,
} as const;

/**
 * Mounted once near the root of the React tree. Subscribes to the toast
 * Zustand store and renders any active toasts as a stack at the bottom-right
 * of the viewport. The toast store handles auto-dismissal via setTimeout, so
 * this component is purely presentational.
 */
export default function Toasts() {
  // `t` já é o toast dentro do map; o tradutor entra com outro nome.
  const { t: traduzir } = useTranslation();
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div className={styles.container} role="status" aria-live="polite">
      {toasts.map((t) => {
        const Icon = ICONS[t.type];
        return (
          <div key={t.id} className={`${styles.toast} ${styles[t.type]}`}>
            <Icon size={18} className={styles.icon} />
            <span className={styles.message}>{t.message}</span>
            <button
              type="button"
              onClick={() => removeToast(t.id)}
              className={styles.close}
              aria-label={traduzir("common.close")}
            >
              <XIcon size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
